// @flow

import React from 'react';
import { BACKEND_FIELDNAMES } from '@streaming-projects/enums';
import { SP_USER_COMMIT_DETAILS_CONFIG_MAP } from '@streaming-projects/user-commit-details/config';
import { CheckBoxField } from '@src/formik-utils/FormFields';

export const SPUserCommitNetNewCustomerContainer = () => {
  const { NET_NEW_CUSTOMER } = BACKEND_FIELDNAMES;
  const { backendFieldName, displayName } = SP_USER_COMMIT_DETAILS_CONFIG_MAP.get(NET_NEW_CUSTOMER);

  return (
    <CheckBoxField
      displayCheckBoxBelowLabel={true}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
    />
  );
};
